import React, { FC, ReactNode } from 'react';
import styles from './Quote.module.scss';

interface IQuoteProps {
	children: ReactNode;
	author: string;
}

const Quote: FC<IQuoteProps> = ({ children, author }) => {
	return (
		<div className={styles.quote}>
			<p className={styles.quoteContent}>{children}</p>
			<div className={styles.quoteAuthor}>{author}</div>
		</div>
	);
};

export default Quote;
